import { Center, Title } from "@mantine/core";
import React from "react";

export default function TitlePage({ children }) {
  return (
    <Center py={20}>
      <Title order={3}>{children}</Title>
    </Center>
  );
}
